

export default class User {

    constructor(obj = null) {
        obj && Object.assign(this, obj);
    };

    setIdUser(id_user){
        this.id_user = id_user;
    };

    getIdUser(){
        return this.id_user;
    };

    setInactive(user_inactive){
        this.user_inactive=user_inactive;
    };

    getInactive(){
        return this.user_inactive;
    };

    setUserName(user_name){
        this.user_name=user_name;
    };

    getUserName(){
        return this.user_name;
    };


    setUserEmail(user_email){
        this.user_email=user_email;
    };

    getUserEmail(){
        return this.user_email;
    };

    getUserRegister(){
        return this.user_register;
    }

    setUserRegister(user_register){
        this.user_register=user_register;
    }

    getUserNumEmp(){
        return this.user_num_emp;
    }

    setUserNumEmp(user_num_emp){
        this.user_num_emp=user_num_emp;
    }

    getUserCResp(){
        return this.user_cresp;
    }

    setUserCResp(user_cresp){
        this.user_cresp=user_cresp;
    }

};


// WEBPACK FOOTER //
// ./src/modules/Models/User.js